import ControlModel from 'scripts/poppet/control-model';

/**
 * poppet.ClusterModel
 * A model for fetching control models.
 * @version 1.0.0
 */
const channel = Bb.Radio.channel( 'objects' );

const ClusterModel = ControlModel.extend( {

	collectionName: null,
	
	url: function() {
		console.warn('ClusterModel: implement child class function url');
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
	{}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	fetch: function( options ) {
		let success = function() { console.log('fetched from app'); }
		if( options && options.success ) {
			success = options.success 
		}

		if( this.get('useBackendApi')) {
			return Bb.Model.prototype.fetch.call( this, options );
		}

		let models = this._getModels();
		for (let index in models ) {
				models[index].fetch( );
		}

		success();
	},

	parse: function( response ) {
		if ( response ) {
			let models = this._getModels();

			for (let index in models ) {
				models[index].parse( response );
			}

			this.receivedData( response );
			if(this.collectionName) {
				channel.request(this.collectionName).add(this, {merge: true});
			}
		}
	},

	save: function( options ) {
		console.log('Do not use ClusterModel to save. Use specific control model');
	},

	refresh: function( options ) {
		this.set('isValidData', false);
		let models = this._getModels();

		for (let index in models ) {
			models[index].set('isValidData', false);
		}

		this.fetch( options );
	},

	getAttributes: function() {
		let models = this._getModels();

		let attrs = '';

		for(let index in models) {
			let model = models[index];
			attrs += model.getAttributes();
			attrs += ",";
		}

		//Remove last comma:
		attrs = attrs.slice(0, -1);

		return attrs;
	},

	_getModels: function() {
		console.warn('ClusterModel: implement _getModels in child class');
	},
	
});

export default ClusterModel;